import receiverAddress from './receiverAddress.vue'

export default receiverAddress
